export const ALLOWED_FIELDS_UPDATE_NORIF = [
  'title',
  'input',
  'sendingTimeSettings',
  'addresses',
  'disabled',
];
